import { useEffect, useMemo, useRef } from 'react'
import {
  SurveyGroupConfig,
  SurveyProgress
} from 'src/redux/slices/project/types'

import { Accordion } from '@material-ui/core'

import SurveySectionDetails from './SurveySectionDetails'
import SurveySectionHeading from './SurveySectionHeading'

type SurveyAccordionProps = {
  group: keyof SurveyProgress
  config: SurveyGroupConfig
  toggleConstructor: (field: keyof SurveyProgress) => () => void
  expanded: { [key in keyof SurveyProgress]: boolean }
  isDrawer?: boolean
}
const SurveyAccordion: React.FC<React.PropsWithChildren<SurveyAccordionProps>> = ({
  children,
  group,
  config,
  toggleConstructor,
  expanded,
  isDrawer,
}) => {
  const ref = useRef<HTMLInputElement>()
  const toggle = useMemo(() => toggleConstructor(group), [group, toggleConstructor])
  const isOpen = expanded[group]
  useEffect(() => {
    if (ref?.current && expanded[group]) {
      setTimeout(() => ref.current?.scrollIntoView({ block: 'center', behavior: 'smooth' }), 250)
    }
  }, [ref, expanded[group]])
  return (
    <Accordion expanded={isOpen} onChange={toggle} ref={ref}>
      <SurveySectionHeading group={group} isDrawer={isDrawer} />
      <SurveySectionDetails group={group} isDrawer={isDrawer}>
        {children}
      </SurveySectionDetails>
    </Accordion>
  )
}
export default SurveyAccordion
